import {
  DemoIndicatorColoredIcon,
  type IconProps,
  PlaybookIcon,
  TourIndicatorColoredIcon,
} from '@carboncopyco/icons';
import {
  LearningHubHubspotIllustration,
  LearningHubSalesforceIllustration,
  LearningHubSpeakerNotesIllustration,
} from '@carboncopyco/illustrations';
import type { TopAssetType, TopAssetsSort } from '@carboncopyco/types';
import type { CapsuleDropdownItem } from '@carboncopyco/ui';
import type { FC } from 'react';
import { LEARNING_HUB_ARTICLE_LINKS } from '../consts';
import type { Article } from './types';

export const iconByAssetType: Record<TopAssetType, FC<IconProps>> = {
  demo: DemoIndicatorColoredIcon,
  tour: TourIndicatorColoredIcon,
  playbook: PlaybookIcon,
};

export const iconTitleByAssetType: Record<TopAssetType, string> = {
  demo: 'Demo (cloned app)',
  tour: 'Tour',
  playbook: 'Playbook',
};

export const commonTypeFilterOptions: CapsuleDropdownItem<TopAssetType>[] = [
  {
    label: 'Demos',
    id: 'demo',
  },
  {
    label: 'Tours',
    id: 'tour',
  },
  {
    label: 'Playbooks',
    id: 'playbook',
  },
];

export const topAssetsSortOptions: CapsuleDropdownItem<TopAssetsSort>[] = [
  { label: 'Popular', id: 'top_results' },
  { label: 'Last updated', id: 'last_updated' },
];

export const emptyStateMessages = {
  isEmptyDueToAllAssetsMarkedAsFavorite:
    "It appears all assets are marked as favorites, so they appear only in the 'Favorites' section up top",
};

type AssetActions =
  | 'visited'
  | 'played'
  | 'updated'
  | 'created'
  | 'shared'
  | 'settings_changed'
  | 'copied'
  | 'duplicated'
  | 'moved';

export const ACTIVITY_TYPES: Record<AssetActions, string> = {
  visited: 'visited',
  played: 'played',
  updated: 'updated',
  created: 'created',
  shared: 'shared',
  settings_changed: 'updated',
  duplicated: 'created',
  copied: 'created',
  moved: 'moved',
};

export const articles: Article[] = [
  {
    illustration: <LearningHubSpeakerNotesIllustration />,
    title: 'Speaker notes: attach guidance or script reminders to demos',
    href: LEARNING_HUB_ARTICLE_LINKS['setting-up-demostack-speaker-notes'],
  },
  {
    illustration: <LearningHubSalesforceIllustration />,
    title: 'Integrate demo data directly into your CRM workflows',
    href: LEARNING_HUB_ARTICLE_LINKS['demostack-and-salesforce-integration'],
  },
  {
    illustration: <LearningHubHubspotIllustration />,
    title: 'Create new leads and send demo analytics to HubSpot',
    href: LEARNING_HUB_ARTICLE_LINKS['demostack-and-hubspot-integration'],
  },
];
